<template>
  <vx-card v-if="generalInfo && activeVenue" no-shadow>
    <h2 class="mb-6">General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Internal note</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.internalNote" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>IDM Venue ID</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <p>{{ activeVenue.venueId }}</p>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Webi entity ID</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <p>{{ generalInfo.webiId }}</p>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>BC Entity</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.bcEntity" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Business Unit</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.businessUnit" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue name</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" @input="nameChange" v-model="generalInfo.name" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Short name</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-on:keypress="isAllowedShortName($event)" v-model="generalInfo.shortName" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>SMS sender name</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" label="Max 11 characters. Only A-z and 0-9 allowed."
          v-on:keypress="isAllowedSmsName($event)" v-model="generalInfo.smsName" />
      </div>
    </div>

    <!-- <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue Type</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" placeholder="Eg. Nightclub 20+" v-model="generalInfo.venueType" />
      </div>
    </div> -->

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue status</span>
      </div>
      <div class="vx-col">
        <vs-select width="100px" v-model="generalInfo.status">
          <vs-select-item :key="index" :value="index" :text="item | uncamelize" v-for="(item, index) in statusOptions" />
        </vs-select>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue category</span>
      </div>
      <div class="vx-col">
        <vs-select width="300px" v-model="generalInfo.category">
          <div :key="index" v-for="(item, index) in categoryOptions">
            <vs-select-group :title="item.title" v-if="item.group">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in item.group" />
            </vs-select-group>
          </div>
        </vs-select>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue province</span>
      </div>
      <div class="vx-col">
        <vs-tooltip
          text="Check this box if this venue is considered to be in the province. If this field is not checked, it is considered to be in a city.">
          <vs-checkbox v-model="generalInfo.isProvince">Is province</vs-checkbox>
        </vs-tooltip>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Description</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <textarea class="vs-inputx vs-input--input normal" style="height: 200px; font-family: Arial; line-height: 1.5rem"
          spellcheck="false" v-model="generalInfo.description" placeholder="Venue description..." />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>VAT number</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.vat" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Bank info</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" label="Bank account" v-model="generalInfo.bankInfo.bankAccount" />
        <vs-input class="w-full" label="Bank account tax" v-model="generalInfo.bankInfo.bankAccountTax" />
        <vs-input class="w-full" label="Secondary bank account" v-model="generalInfo.bankInfo.bankAccountSecondary" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue size (m2)</span>
      </div>
      <div class="vx-col">
        <vs-input-number v-model="generalInfo.size" label="m2" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Max Capacity</span>
      </div>
      <div class="vx-col">
        <vs-input-number label="Guests" v-model="generalInfo.capacity" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Tags</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Tags</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips color="rgb(145, 32, 159)" placeholder="New Tag" v-model="generalInfo.tags">
          <vs-chip :key="tag" @click="removeTag(tag, generalInfo.tags)" v-for="tag in generalInfo.tags" closable>
            {{ tag }}
          </vs-chip>
        </vs-chips>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-1">Areas</h5>
      <div class="text-grey mb-6">
        Click and drag an area instance to change position
      </div>
    </div>

    <div class="vx-row mb-6" v-for="areaName in Object.keys(generalInfo.areas)" :key="areaName">
      <div class="vx-col sm:w-1/5 w-full">
        <span>{{ areaName }}</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full" @keydown.enter="onAreaAdded(areaName)">
        <vs-chips color="rgb(145, 32, 159)" placeholder="Type to add area instance" v-model="generalInfo.areas[areaName]">
          <draggable :list="generalInfo.areas[areaName]" :animation="200" ghost-class="moving-area">
            <vs-chip :key="areaInstance" v-for="areaInstance in generalInfo.areas[areaName]"
              @click="removeArea(areaName, areaInstance)" closable class="cursor-move mr-0">
              {{ areaInstance }}
            </vs-chip>
          </draggable>
        </vs-chips>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-1">PIM Stock Setup</h5>
      <div class="text-grey mb-6">
        Locations can be arranged freely. Main stock cannot be removed or added.
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Stock locations</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips color="rgb(145, 32, 159)" placeholder="Type to add area instance"
          v-model="generalInfo.pimStockLocations.locations">
          <draggable :list="generalInfo.pimStockLocations.locations" :animation="200" ghost-class="moving-area">
            <vs-chip :key="location.id" v-for="location in generalInfo.pimStockLocations.locations"
              @click="removeLocation(id)" closable class="cursor-move mr-0">
              {{ location.name }}
            </vs-chip>
          </draggable>
        </vs-chips>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Tobacco info</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Mandatory info</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input placeholder="Entity number" label="Entity number" class="mr-2"
            v-model="generalInfo.tobaccoInfo.entityNumber" />
          <vs-input placeholder="Entity code" label="Entity code" class="mr-2"
            v-model="generalInfo.tobaccoInfo.entityCode" />
          <vs-input placeholder="Facility code" label="Facility code" class="mr-2"
            v-model="generalInfo.tobaccoInfo.facilityCode" />
        </vs-row>
      </div>
    </div>

    <vs-divider />

    <!--     <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Licensed managers</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Licensed manaagers</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips
          color="rgb(145, 32, 159)"
          placeholder="New licensed manager"
          v-model="generalInfo.licensedManagers.names"
        >
          <vs-chip
            :key="tag"
            @click="removeTag(tag, generalInfo.licensedManagers.names)"
            v-for="tag in generalInfo.licensedManagers.names"
            closable
          >
            {{ tag }}
          </vs-chip>
        </vs-chips>
      </div>
    </div> -->
    <!--
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Note</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.licensedManagers.note" />
      </div>
    </div> -->

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Cleaning duty</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>General sidewalk cleaning</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-switch color="success" v-model="generalInfo.cleaningDuty.generalSidewalkCleaning" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Snow shovelling</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-switch color="success" v-model="generalInfo.cleaningDuty.snowShoveling" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Info</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" label="Note" v-model="generalInfo.cleaningDuty.note" />
        <vs-input class="w-full" label="Company name" v-model="generalInfo.cleaningDuty.companyName" />
        <vs-input class="w-full" label="Company phone" v-model="generalInfo.cleaningDuty.companyPhone" />
        <vs-input class="w-full" label="Company email" v-model="generalInfo.cleaningDuty.companyMail" />
        <vs-input class="w-full" label="Company contact" v-model="generalInfo.cleaningDuty.companyContactPerson" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-2">Additional contact</h5>
      <p class="mb-6">See 'Contacts' tab for position contacts.</p>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Primary Email</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.email" />
      </div>
    </div>

    <div class="vx-row mb-6" v-for="(p, idx) in contactPeople" :key="'b' + idx">
      <div class="vx-col sm:w-1/5 w-full">
        <span>{{ p.name }}</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input placeholder="Full name" class="mr-2" v-model="generalInfo[p.key].name" />
          <vs-input placeholder="Phone number" class="mr-2" v-model="generalInfo[p.key].phone" />
          <vs-input placeholder="E-mail" class="mr-2" v-model="generalInfo[p.key].mail" />
          <vs-input placeholder="Note" class="mt-2" v-model="generalInfo[p.key].note" />
        </vs-row>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Licensed managers</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <Loading v-if="!hasContactInfo" text="Fetching users" />
        <div v-else class="vx-col sm:w-2/5 w-full">
          <p v-for="user in contactUsers.filter((e) => e.userRole === 'lm')" :key="user.userId">
            {{ user.firstName }} {{ user.lastName }} - {{ user.email }} -
            {{ user.phoneCountryCode }}{{ user.phone }} ({{
              user.validFromDate | date
            }}
            - {{ user.validToDate | date }})
          </p>
        </div>
      </div>
    </div>

    <!--   <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Entrance & wardrobe</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Entrance</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input placeholder="When" label="When" class="mr-2" v-model="generalInfo.entrance.when" />
          <vs-input
            placeholder="Price (in local currency)"
            label="Price"
            class="mr-2"
            v-model="generalInfo.entrance.price"
          />
          <vs-input placeholder="Note" label="Note" class="mr-2" v-model="generalInfo.entrance.note" />
        </vs-row>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Wardrobe</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input placeholder="When" label="When" class="mr-2" v-model="generalInfo.wardrobe.when" />
          <vs-input
            placeholder="Price (in local currency)"
            label="Price"
            class="mr-2"
            v-model="generalInfo.wardrobe.price"
          />
          <vs-input placeholder="Note" label="Note" class="mr-2" v-model="generalInfo.wardrobe.note" />
        </vs-row>
      </div>
    </div> -->

    <!-- <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Private area</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Possible to rent</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-switch color="success" v-model="generalInfo.privateArea.possibleToRent" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Possible to dine</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-switch color="success" v-model="generalInfo.privateArea.possibleToDine" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Offers</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input placeholder="Offers" class="mr-2" v-model="generalInfo.privateArea.offers" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Other</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input placeholder="Other" class="mr-2" v-model="generalInfo.privateArea.other" />
      </div>
    </div> -->

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">FAQ</h5>
    </div>

    <div class="vx-row mb-6" v-for="qa in generalInfo.faq" :key="qa.key">
      <div class="vx-col sm:w-1/5 w-full">
        <span>{{ qa.key }}</span>
        <feather-icon @click="deleteFaq(qa.key)" icon="XIcon" svgClasses="h-4 w-4" class="cursor-pointer ml-1"
          size="small"></feather-icon>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <p>{{ qa.value }}</p>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>New QA</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input placeholder="Question" class="mr-2" v-model="newQuestion" />
          <vs-input placeholder="Answer" class="mr-2" v-model="newAnswer" />
          <vs-button :disabled="newQuestion === '' || newAnswer === ''" @click="submitQA">Add</vs-button>
        </vs-row>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Lost & found</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Message in Danish</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea placeholder="Lost and found message in Danish" class="mr-2"
          v-model="generalInfo.lostFoundMessageToGuestDK" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Message in English</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea placeholder="Lost and found message in English" class="mr-2"
          v-model="generalInfo.lostFoundMessageToGuestEN" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Continia</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Code / ID</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.continiaInfo.code" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue Code</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.continiaInfo.venueCode" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Company</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.continiaInfo.company" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Invoice Email</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.continiaInfo.invoiceEmail" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Socials and integrations</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Phone</span>
      </div>
      <div class="vx-col sm:w-4/5">
        <vs-row>
          <vs-select width="100px" label="Country" v-model="generalInfo.phoneCountryCode">
            <vs-select-item :key="'a' + index" :value="item.value" :text="item.text"
              v-for="(item, index) in phoneCodeOptions" />
          </vs-select>
          <vs-input class="ml-3" label="Number" v-model="generalInfo.phone" />
          <vs-input class="ml-3" label="Phone note" v-model="generalInfo.phoneNote" />
        </vs-row>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Platforms</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" label="Website link" v-model="generalInfo.website" />
        <vs-input class="w-full" label="Ticket sale link" v-model="generalInfo.socialPlatforms.ticketSaleLink" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Integrations</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" label="Google Drive folder ID"
          v-model="generalInfo.socialPlatforms.googleDriveFolderId" />
        <vs-input class="w-full" label="FIXR Venue ID" v-model="generalInfo.socialPlatforms.fixrVenueId" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Socials</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" label="Facebook link" v-model="generalInfo.socialPlatforms.facebookLink" />
        <vs-input class="w-full" label="Instagram link" v-model="generalInfo.socialPlatforms.instagramLink" />
        <vs-input class="w-full" label="Whatsapp number" v-model="generalInfo.socialPlatforms.whatsappNumber" />
        <vs-input class="w-full" label="Snapchat username" v-model="generalInfo.socialPlatforms.snapchatUsername" />
        <vs-input class="w-full" label="Tiktok username" v-model="generalInfo.socialPlatforms.tiktokUsername" />
        <vs-input class="w-full" label="Messenger page ID" v-model="generalInfo.socialPlatforms.messengerId" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Analytics and pixels</span><br /><small>Tracking services may or not be enabled for this venue.</small>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" label="Google Tag Manager ID" v-model="generalInfo.analyticsDetails.tagManagerId" />
        <vs-input class="w-full" label="Google Analytics (GA4) ID"
          v-model="generalInfo.analyticsDetails.googleAnalyticsId" />
        <vs-input class="w-full" label="Facebook/Meta Pixel ID" v-model="generalInfo.analyticsDetails.facebookPixelId" />
        <vs-input class="w-full" label="Facebook/Meta Api Access Token (for CAPI)"
          v-model="generalInfo.analyticsDetails.facebookApiToken" />
        <vs-input class="w-full" label="Google Ads ID" v-model="generalInfo.analyticsDetails.googleAdsId" />
        <vs-input class="w-full" label="Snapchat Pixel ID" v-model="generalInfo.analyticsDetails.snapchatPixelId" />
        <vs-input class="w-full" label="Tiktok Pixel ID" v-model="generalInfo.analyticsDetails.tiktokPixelId" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Styling <small>(CRM)</small></h5>
    </div>

    <div class="vx-row mb-6" v-for="(item, index) in colors" :key="'c' + index">
      <div class="vx-col sm:w-1/5 w-full">
        <span>{{ colorNames[index] }}</span>
      </div>
      <div class="vx-col">
        <input v-model="generalInfo.style[item]" type="color" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Border radius</span>
      </div>
      <div class="vx-col">
        <vs-input-number v-model="generalInfo.style.borderRadius" label="px" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Logo</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <img :src="generalInfo.logoUrl" v-if="generalInfo.logoUrl" class="logoDisplay mb-2" alt="logo" />
        <label class="custom-file-upload">
          <input type="file" @change="uploadNormalLogo" accept=".jpg,.jpeg,.png" />
          <i class="fa fa-cloud-upload"></i> Choose new
        </label>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Receipt logo</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <img :src="generalInfo.receiptLogoUrl" v-if="generalInfo.receiptLogoUrl" class="logoDisplay mb-2" alt="logo" />
        <label class="custom-file-upload">
          <input type="file" @change="uploadReceiptLogo" accept=".jpg,.jpeg,.png" />
          <i class="fa fa-cloud-upload"></i> Choose new
        </label>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5>Photos &amp; Videos</h5>
    </div>
    <VenueImages v-if="generalInfo" :venueId="activeVenue.venueId" :venue="generalInfo" style="width: 100%" />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button v-if="hasPermissionForActiveVenue('vp.vp.venueinfo.edit')" @click="saveInfo" id="save-button"
        class="ml-auto mt-2">Save General</vs-button>
    </div>
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";
import Draggable from "vuedraggable";
import * as _ from "lodash";

const VenueImages = () => import("./VenueImages.vue");
export default {
  components: { VenueImages, Draggable },

  data() {
    return {
      hasContactInfo: false,
      newQuestion: "",
      newAnswer: "",
      colors: [
        "colorBackground",
        "colorFont",
        "colorPrimaryCta",
        "colorPrimaryCtaFont",
        "colorBackgroundFields",
        "colorBackgroundPage",
        "colorBorder",
        "colorBorderBottom",
        "colorFieldsInput",
        "colorFieldsLabels",
        "colorFieldsPlaceholders",
        "colorPrices",
      ],
      colorNames: [
        "Background color",
        "Font color",
        "Primary CTA color",
        "Primary CTA font color",
        "Background fields color",
        "Background page color",
        "Border color",
        "Border bottom color",
        "Fields input color",
        "Fields label color",
        "Field placeholder color",
        "Prices color",
      ],
      contactPeople: [
        /*         {
          key: "snrChannelActivationManager",
          name: "Snr Channel Activation Manager",
        },
        {
          key: "channelActivationManager",
          name: "Channel Activation Manager",
        },
        {
          key: "siteManager",
          name: "Site manager",
        }, */
        /* {
          key: "generalInquiries",
          name: "General inquriries",
        }, */
        {
          key: "bookingContact",
          name: "Booking",
        },
        {
          key: "lostAndFoundContact",
          name: "Lost and found",
        },
        {
          key: "landlordContact",
          name: "Landlord",
        },
        {
          key: "powerSupplier",
          name: "Power supplier",
        },
      ],
      phoneCodeOptions: [
        { text: "+45 DK", value: "+45" },
        { text: "+47 NO", value: "+47" },
        { text: "+358 FI", value: "+358" },
        { text: "+44 UK", value: "+44" },
      ],
      statusOptions: ["Open", "Closed", "NoneVenue"],
      categoryOptions: [
        {
          title: "Nightclubs",
          group: [
            { text: "Hybrid / Themed Clubs", value: 0 },
            { text: "Commercial / Main Room Clubs", value: 1 },
            { text: "Botique Clubs", value: 2 },
          ],
        },
        {
          title: "Dining",
          group: [
            { text: "Café", value: 3 },
            { text: "Resturant", value: 4 },
            { text: "Party Dining", value: 5 },
          ],
        },
        {
          title: "Bars & Pubs",
          group: [
            { text: "Classic Bar", value: 6 },
            { text: "Wine Bar", value: 7 },
            { text: "Craft Beer Bar", value: 8 },
            { text: "Cocktail Bar", value: 9 },
            { text: "Game Bar", value: 10 },
            { text: "Party Bar", value: 11 },
            { text: "Brown Pub", value: 12 },
            { text: "Classic Pub", value: 13 },
            { text: "Brew Pub", value: 14 },
            { text: "Gastro Pub", value: 15 },
            { text: "Party Sub", value: 16 },
          ],
        },
        {
          title: "Festival & Events",
          group: [
            { text: "Festival", value: 18 },
            { text: "Events", value: 19 },
          ],
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      generalInfo: "venues/generalInfo",
      activeVenue: "venues/activeVenue",
      contactUsers: "venues/contactUsers",
      contactRoles: "venues/contactRoles",
      contactRolesMap: "venues/contactRolesMap",
    }),
  },
  methods: {
    async uploadReceiptLogo(event) {
      const file = event.target.files[0];
      const url = await this.uploadLogo(file);
      this.generalInfo.receiptLogoUrl = url;
      console.log("Logo URL", url);
    },
    async uploadNormalLogo(event) {
      const file = event.target.files[0];
      const url = await this.uploadLogo(file);
      this.generalInfo.logoUrl = url;
      console.log("Logo URL", url);
    },
    async uploadLogo(file) {
      const fileExtension = file.name.split(".").pop();
      const fileName = this.uuidv4() + "." + fileExtension;
      const fileUrl = `https://rekomlifestorageprod.blob.core.windows.net/venue-logo/${fileName}`;
      const url = `${fileUrl}?sp=racwdli&st=2023-06-08T09:45:21Z&se=2029-09-30T17:45:21Z&sv=2022-11-02&sr=c&sig=yLi4pP50716BFvJG3jBaw5dIJ%2BnNFgEW2uWydsibVjo%3D`;
      let headers = new Headers();
      headers.append("x-ms-blob-type", "BlockBlob");
      let requestOptions = {
        method: "PUT",
        headers: headers,
        body: file,
        redirect: "follow",
      };
      await fetch(url, requestOptions);
      return fileUrl;
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    nameChange() {
      // turn this.generalInfo.shortName into camel case version of this.generalInfo.name
      this.generalInfo.shortName = _.camelCase(this.generalInfo.name);
    },
    isAllowedShortName(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z]+$/.test(char)) return true;
      else e.preventDefault();
    },
    isAllowedSmsName(e) {
      if (this.generalInfo.smsName.length >= 11 && e.keyCode !== 8) {
        e.preventDefault();
      }

      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9 ]+$/.test(char) || e.keyCode === 8) {
        return true;
      } else {
        e.preventDefault();
      }
    },
    onAreaAdded(areaName) {
      setTimeout(() => {
        // Capitalize and remove duplicates
        this.generalInfo.areas[areaName] = _.chain(
          this.generalInfo.areas[areaName]
        )
          .map((e) => _.capitalize(e))
          .uniq()
          .value();
      }, 2);
    },
    removeArea(areaName, areaInstance) {
      this.generalInfo.areas[areaName] = this.generalInfo.areas[
        areaName
      ].filter((e) => e != areaInstance);
    },
    deleteFaq(key) {
      if (confirm("Sure you want to delete this question?"))
        this.generalInfo.faq = this.generalInfo.faq.filter(
          (e) => e.key !== key
        );
    },
    submitQA() {
      this.generalInfo.faq.push({
        key: this.newQuestion,
        value: this.newAnswer,
      });
      this.newQuestion = "";
      this.newAnswer = "";
    },
    removeTag(item, tags) {
      tags.splice(tags.indexOf(item), 1);
    },
    async saveInfo() {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#save-button",
        scale: 0.45,
      });
      this.generalInfo.style.borderRadius = parseInt(
        this.generalInfo.style.borderRadius
      );
      const dto = {
        ...this.generalInfo,
        capacity: parseInt(this.generalInfo.capacity),
        size: parseInt(this.generalInfo.size),
      };
      this.$store
        .dispatch("venues/updateGeneralInfo", dto)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "green",
            title: "Success",
            text: "General info saved",
          });
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not save general info: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close("#save-button > .con-vs-loading");
        });
    },
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("venues/getGeneralInfo");
    console.log("received", this.generalInfo);
    this.$vs.loading.close();
    await this.$store.dispatch("venues/getContactUsers", "lm");
    this.hasContactInfo = true;
  },
};
</script>

<style lang="scss" scoped>
.logoDisplay {
  max-width: 300px;
  height: auto;
  border-radius: 15px;
  background: repeating-conic-gradient(#808080 0% 25%, transparent 0% 50%) 50% / 20px 20px;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.con-chips--remove-all {
  display: none;
}

.moving-area {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px dashed #4299e1;
}
</style>
